import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    payroll: [],
}

const payrollSlice = createSlice({
    name: 'payroll',
    initialState,
    reducers: {
        addPayroll: (state, action)=>{
            state.payroll = action.payload
        },
    }
})

export const handleAddPayroll = (state)=>{
    return dispatch => {
        dispatch(payrollSlice.actions.addPayroll(state))
    }
}


export default payrollSlice.reducer